var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh"}},[(_vm.type===0)?_c('el-result',{staticStyle:{"margin-top":"20vh"},attrs:{"title":_vm.content,"icon":"error","subTitle":_vm.timeContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }